import CheckIcon from "@mui/icons-material/Check";
import { Button, Dialog, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import React, { useEffect, useState } from "react";
import { VendorTicketDetail } from "../../../../@types/DRO/WarrantyTicketsResponse";
import { WarrantyTicketsApi } from "../../../../api/WarrantyTickets/WarrantyTicketsApi";
import { useLoading } from "../../../../views/Loader/LoadingContext";

interface RepairDialogProps {
  open: boolean;
  row: VendorTicketDetail | null;
  onClose: () => void;
  onSuccess: () => void;
}

const RepairDialog: React.FC<RepairDialogProps> = ({ open, row, onClose, onSuccess }) => {
  const { setLoading } = useLoading();
  const [successOpen, setSuccessOpen] = useState(false);
  const [hubs, setHubs] = useState<{ hubId: number; hubName: string }[]>([]);
  const [selectedHubId, setSelectedHubId] = useState<string>("");

  useEffect(() => {
    if (open) {
      setSelectedHubId("");
      WarrantyTicketsApi.api.getHubList().then(setHubs).catch(console.error);
    }
  }, [open]);

  const handleClose = () => {
    setSelectedHubId("");
    onClose();
  };

  const handleConfirm = async () => {
    if (!row) return;
    handleClose();
    setLoading(true);
    try {
      await WarrantyTicketsApi.api.warrantyTicketAction({
        warrantyActionItems: [{ uid: row.uid, action: "REPAIR", imageId: row.imageId, remarks: "", hubId: Number(selectedHubId) }],
      });
      setSuccessOpen(true);
      onSuccess();
    } catch (error) {
      console.error("Error repairing ticket", error);
    }
    setLoading(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{ sx: { borderRadius: 3, p: 3, width: 340 } }}>
        <p className="text-center text-gray-700 mb-4 leading-snug">
          Are you sure you want to Mark<br />the Part for Repairing?
        </p>
        <FormControl fullWidth size="small" sx={{ mb: 4 }}>
          <InputLabel>Select Hub</InputLabel>
          <Select
            label="Select Hub"
            value={selectedHubId}
            onChange={(e: SelectChangeEvent) => setSelectedHubId(e.target.value)}>
            {hubs.map((h) => (
              <MenuItem key={h.hubId} value={String(h.hubId)}>{h.hubName}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <div className="flex items-center justify-center gap-3">
          <Button
            variant="outlined"
            size="small"
            onClick={handleClose}
            sx={{ textTransform: "none", borderRadius: 5, borderColor: "#ccc", color: "#333", "&:hover": { borderColor: "#999" } }}>
            No, Go Back
          </Button>
          <Button
            variant="contained"
            size="small"
            disabled={!selectedHubId}
            onClick={handleConfirm}
            sx={{ textTransform: "none", borderRadius: 5, bgcolor: "#2563EB", "&:hover": { bgcolor: "#1D4ED8" } }}>
            Yes, Continue
          </Button>
        </div>
      </Dialog>

      <Dialog
        open={successOpen}
        onClose={() => setSuccessOpen(false)}
        PaperProps={{ sx: { borderRadius: 3, p: 4, width: 280 } }}>
        <div className="flex flex-col items-center gap-4">
          <div className="w-16 h-16 rounded-full bg-blue-600 flex items-center justify-center">
            <CheckIcon sx={{ color: "white", fontSize: 36 }} />
          </div>
          <p className="text-gray-800 font-semibold text-center">Part Marked for Repairing!</p>
        </div>
      </Dialog>
    </>
  );
};

export default RepairDialog;
